/**
 * Canonical React Query cache key contract for community chat hooks.
 *
 * Socket event handlers depend on the *exact* shape of these keys to
 * target the matching query, so do not change the array layout without
 * updating both producers (hooks) and consumers (socket cache sync).
 */
export const QK = {
  root: ["community_chat"] as const,
  conversations: () => [...QK.root, "conversations"] as const,
  conversation: (id: string) => [...QK.root, "conversation", id] as const,
  messages: (conversationId: string) =>
    [...QK.root, "messages", conversationId] as const,
  unreadSummary: () => [...QK.root, "unreadSummary"] as const,
  attachments: (conversationId: string) =>
    [...QK.root, "attachments", conversationId] as const,
  presence: (userId: string) => [...QK.root, "presence", userId] as const,
};

export type MessagesQueryKey = ReturnType<typeof QK.messages>;
export type ConversationsQueryKey = ReturnType<typeof QK.conversations>;
